define(["react","underscore","prop-types","@bingads-webui-react/hoc-with-instrumentation","hoist-non-react-statics","@bingads-webui-react/hoc-utils"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__119__, __WEBPACK_EXTERNAL_MODULE__120__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 685);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__119__;

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__120__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(686);


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withSignal", {
  enumerable: true,
  get: function get() {
    return _withSignal.withSignal;
  }
});
Object.defineProperty(exports, "CommonEventParser", {
  enumerable: true,
  get: function get() {
    return _withSignal.CommonEventParser;
  }
});
Object.defineProperty(exports, "FabricDropdownParser", {
  enumerable: true,
  get: function get() {
    return _withSignal.FabricDropdownParser;
  }
});
Object.defineProperty(exports, "ActivityContext", {
  enumerable: true,
  get: function get() {
    return _activityContextProvider.ActivityContext;
  }
});
Object.defineProperty(exports, "Activity", {
  enumerable: true,
  get: function get() {
    return _activityContextProvider.Activity;
  }
});
Object.defineProperty(exports, "withActivityContext", {
  enumerable: true,
  get: function get() {
    return _activityContextProvider.withActivityContext;
  }
});
Object.defineProperty(exports, "ScenarioContext", {
  enumerable: true,
  get: function get() {
    return _scenarioContextProvider.ScenarioContext;
  }
});
Object.defineProperty(exports, "Scenario", {
  enumerable: true,
  get: function get() {
    return _scenarioContextProvider.Scenario;
  }
});
Object.defineProperty(exports, "withScenarioContext", {
  enumerable: true,
  get: function get() {
    return _scenarioContextProvider.withScenarioContext;
  }
});

var _withSignal = __webpack_require__(687);

var _activityContextProvider = __webpack_require__(688);

var _scenarioContextProvider = __webpack_require__(689);

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FabricDropdownParser = exports.CommonEventParser = exports.withSignal = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(119));

var _activityContextProvider = __webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const withSignal = (WrappedComponent, SignalAdaptor) => {
  class HoC extends _react.default.Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "render", () => {
        const shimmedProps = {};

        _underscore.default.map(Object.keys(SignalAdaptor), event => {
          // call logger first then call the original handler
          // not using _.compose because the original handler may expect multiple params
          // and _.compose can only pass one param
          const shimmedHandler = (...e) => {
            if (this.props.activity) {
              this.props.activity.signal(_underscore.default.assign(SignalAdaptor[event](e), {
                event
              }));
            }

            if (this.props[event]) {
              this.props[event](...e);
            }
          };

          shimmedProps[event] = shimmedHandler.bind(this);
        });

        return _react.default.createElement(WrappedComponent, _extends({}, this.props, shimmedProps));
      });
    }

  }

  HoC.propTypes = {
    activity: _propTypes.default.object
  };
  HoC.defaultProps = {
    activity: undefined
  };
  return (0, _activityContextProvider.withActivityContext)((0, _hoistNonReactStatics.default)(HoC, WrappedComponent));
};

exports.withSignal = withSignal;

const CommonEventParser = e => {
  if (e[0] && e[0].currentTarget) {
    return {
      className: e[0].currentTarget.className,
      name: e[0].currentTarget.name,
      id: e[0].currentTarget.id,
      text: e[0].currentTarget.innerText,
      value: e[0].currentTarget.value,
      'data-analyticsid': e[0].currentTarget.dataset && e[0].currentTarget.dataset.analyticsid
    };
  }

  return {};
};

exports.CommonEventParser = CommonEventParser;

const FabricDropdownParser = e => ({
  className: e[0].target.className,
  name: e[0].target.name,
  id: e[0].target.id,
  text: e[1].text,
  value: e[1].value
});

exports.FabricDropdownParser = FabricDropdownParser;

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withActivityContext = exports.Activity = exports.ActivityContext = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(119));

var _hocUtils = __webpack_require__(120);

var _scenarioContextProvider = __webpack_require__(689);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// if no activity context is provided, defaultActivity will be used
const ActivityContext = _react.default.createContext();

exports.ActivityContext = ActivityContext;

const Activity = props => {
  const context = (0, _react.useContext)(_scenarioContextProvider.ScenarioContext);
  const activityContext = (0, _react.useMemo)(() => context && props.name ? context.createActivity(props.name) : undefined, [context, props.name]);
  return _react.default.createElement(ActivityContext.Provider, {
    value: activityContext
  }, props.children);
};

exports.Activity = Activity;
Activity.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  name: _propTypes.default.string
};
Activity.defaultProps = {
  name: undefined
};

const withActivityContext = WrappedComponent => {
  const HoC = props => _react.default.createElement(ActivityContext.Consumer, null, context => _react.default.createElement(WrappedComponent, _extends({}, props, {
    activity: context
  })));

  HoC.displayName = `withActivityContext(${(0, _hocUtils.getDisplayName)(WrappedComponent)})`;
  return (0, _hoistNonReactStatics.default)(HoC, WrappedComponent);
};

exports.withActivityContext = withActivityContext;

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withScenarioContext = exports.Scenario = exports.ScenarioContext = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(119));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _hocUtils = __webpack_require__(120);

var _hocWithInstrumentation = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ScenarioContext = _react.default.createContext();

exports.ScenarioContext = ScenarioContext;

const Scenario = props => {
  const instrumentation = (0, _react.useContext)(_hocWithInstrumentation.InstrumentationContext);
  const context = (0, _react.useContext)(ScenarioContext);
  const scenarioInstance = (0, _react.useMemo)(() => {
    if (props.name) {
      if (context && context.value === props.name) {
        // if parent scenario and current one share the same name
        // reuse parent scenario instance
        return context;
      } else if (instrumentation && instrumentation.createScenario) {
        // otherwise create a new scenario instance and pass in parent scenario instance
        // which could be undefined or null
        return instrumentation.createScenario({
          scenarioName: props.name,
          parentScenario: context
        });
      }
    }

    return undefined;
  }, [context, instrumentation, props.name]);
  return _react.default.createElement(ScenarioContext.Provider, {
    value: scenarioInstance
  }, props.children);
};

exports.Scenario = Scenario;
Scenario.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  name: _propTypes.default.string.isRequired
};

const withScenarioContext = WrappedComponent => {
  const HoC = props => {
    const context = (0, _react.useContext)(ScenarioContext);
    return _react.default.createElement(WrappedComponent, _extends({}, props, {
      scenario: context
    }));
  };

  HoC.displayName = `withScenarioContext(${(0, _hocUtils.getDisplayName)(WrappedComponent)})`;
  return (0, _hoistNonReactStatics.default)(HoC, WrappedComponent);
};

exports.withScenarioContext = withScenarioContext;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
